import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { Cart } from '../../@types/cart';

@Injectable({
    providedIn: 'root'
})
export class StorageSyncService implements OnDestroy {
    private readonly storageEvent$: Observable<StorageEvent> = fromEvent<StorageEvent>(window, 'storage');
    private storageEventSubscriptionRef: Subscription | undefined;

    constructor() {}

    public setupStorageSyncronization(): void {
        this.storageEventSubscriptionRef = this.storageEvent$.subscribe((event) => {
            if (this.isCartEvent(event) && this.hasCartBeenReset(event)) {
                this.resetApplication();
            }
        });
    }

    private hasCartBeenReset(storageEvent: StorageEvent): boolean {
        if (!storageEvent.newValue) return false;

        const newCartValueFromStorage = JSON.parse(storageEvent.newValue) as Cart;

        return newCartValueFromStorage.count === 0;
    }

    private isCartEvent(storageEvent: StorageEvent): boolean {
        return storageEvent.key === 'cart';
    }

    private resetApplication(): void {
        window.location.href = '/';
    }

    ngOnDestroy() {
        this.storageEventSubscriptionRef?.unsubscribe();
    }
}
